
export abstract class Entidade {

    id?: number;
    uuid?: string;

}